export const statusNormalizeMap = new Map<string, string>([
  ['REQUESTED', 'SCHEDULED'],
  ['REQUEST_REJECTED', 'FAILED'],
  ['CANCELLED', 'FAILED'],
  ['SCHEDULED', 'SCHEDULED'],
  ['DELIVERED', 'DELIVERED'],
  ['LOST', 'FAILED'],
  ['UNAVAILABLE', 'FAILED']
]);
